import React, { useContext, useEffect, useState } from 'react'
import AccountInformationCard from '../../utility/accountInformationCard';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { useNavigate, useSearchParams } from 'react-router-dom';
import agent from '../../../services/api';
import { MetaContext, MetaContextPayload } from '../../../context/metaContext';
import { addChatbotIntegrationPayload, globalIntegration, metaIntegrationAccessTokenData, metaIntegrationPhoneNumberData, metaIntegrationWhatsappData, removeChatbotIntegrationDetailsInterface } from '../../../models/axiosModel';
import GlobalPopUp from '../../utility/globalPopUp';
import GlobalDeletePopup from '../../utility/globalDeletePopup/globalDeletePopup';
import Confirmation from '../../popupFiles/confirmation';
import { ChatbotContext, ChatbotContextPayload } from '../../../context/chatbotContext';
import { IntegrationContext, IntegrationContextPayload } from '../../../context/integrationContext';
import { GenericDataContext, GenericDataContextPayload } from '../../../context/genericDataContext';
import { AIChatbotBreadcrumb, chatbotDetailsBreadcrumb, homeBreadcrumb, integrationDetailsBreadcrumb } from '../../../utils/breadcrumb';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

const ChatbotWhatsAppIntegrationDetails = () => {
    const navigate = useNavigate()
    const [currentActiveWhatsappIntegration, setCurrentActiveWhatsappIntegration] = useState<metaIntegrationWhatsappData[] | null>(null)
    const { chatBotDetails } = useContext(ChatbotContext) as ChatbotContextPayload
    const [searchParams] = useSearchParams() 
    const chatbot_id = searchParams.get('chatbot_id');
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    const { GetChatbotIntegrationData, getChatbotIntegrationData, setGetChatbotIntegrationData } = useContext(MetaContext) as MetaContextPayload; 
    const { setBreadCrumbs } = useContext(GenericDataContext) as GenericDataContextPayload;
    const { globalIntegrationTypeList } = useContext(IntegrationContext) as IntegrationContextPayload;

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState<boolean>(false);
    const [flagAddIntegration, setFlagAddIntegration] = useState<boolean>(false)
    const [phoneNumberIntegrate, setPhoneNumberIntegrate] = useState<string>("")

    const [addChatbotIntegrationDetails, setAddChatbotIntegrationDetails] = useState<addChatbotIntegrationPayload>({
        chatbot_id: "",
        integrated_channel_id: ""
    })
    const [removeChatbotIntegrationDetails, setRemoveChatbotIntegrationDetails] = useState<removeChatbotIntegrationDetailsInterface>({
        chatbot_id: "",
        integrated_channel_id: ""
    })
    let pathname = window.location.pathname.toLowerCase();

    useEffect(() => {
        if (getChatbotIntegrationData !== null && getChatbotIntegrationData.length > 0 && getChatbotIntegrationData.flatMap((integration: globalIntegration) => integration.meta_integration_whatsapp_data).filter((data) => data).length > 0) {
            let assignment_id = Number(searchParams.get('assignment_id'))
            if (assignment_id) {
                let whatsapIntegrationData = getChatbotIntegrationData.flatMap((item) => {
                    const {
                        // meta_integration_id, 
                        meta_integration_type_assignment_data } = item;
                    // const { meta_integration_type_id } = meta_integration_type_assignment_data;
                    const whatsappData = item.meta_integration_whatsapp_data;

                    if (whatsappData) {
                        return {
                            ...whatsappData,
                            // meta_integration_id, 
                            // meta_integration_type_id 
                        };
                    }

                    return [];
                });
                let currentActiveWhatsappData = whatsapIntegrationData.filter((data) => data.meta_integration_whatsapp_id == assignment_id)
                if (currentActiveWhatsappData && currentActiveWhatsappData.length > 0) {
                    setCurrentActiveWhatsappIntegration(currentActiveWhatsappData)
                } else {
                    let chatbot_id = searchParams.get('chatbot_id')
                    navigate(`/chatbot/viewchatbot/channels/whatsapp?chatbot_id=${chatbot_id}`)
                }
            } else {
                let chatbot_id = searchParams.get('chatbot_id')
                navigate(`/chatbot/viewchatbot/channels/whatsapp?chatbot_id=${chatbot_id}`)
            }
        } else {
            let chatbot_id = searchParams.get('chatbot_id')
            navigate(`/chatbot/viewchatbot/channels/whatsapp?chatbot_id=${chatbot_id}`)
        }
    }, [getChatbotIntegrationData, window.location.href])

    useEffect(() => {
        const updatedBreadcrumbs = [
            {...homeBreadcrumb}, 
            AIChatbotBreadcrumb, 
            {...chatbotDetailsBreadcrumb, name: chatBotDetails?.chatbot_name ? chatBotDetails?.chatbot_name : "Chatbot", path: `/chatbot/viewchatbot/basicdetail?chatbot_id=${chatbot_id}`}, 
            { name: "WhatsApp Integration", path: `/chatbot/viewchatbot/channels/whatsapp?chatbot_id=${chatbot_id}`, isActive: false}, 
            { ...integrationDetailsBreadcrumb, isActive: true }
        ]; 
        setBreadCrumbs(updatedBreadcrumbs);
    }, [chatBotDetails])

    const deleteChatbotIntegration = async () => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
        let channel_id = globalIntegrationTypeList?.find((channel) => channel?.channel_name?.toLowerCase() == 'whatsapp')?.channel_id.toString() || ''
        const response = await agent.removeChatbotIntegration.delete(
            channel_id, 
            removeChatbotIntegrationDetails.chatbot_id,
            removeChatbotIntegrationDetails.integrated_channel_id
        );
        if (response.status) {
            showSuccess("Integration Removed Successfully")
            const res = await GetChatbotIntegrationData(removeChatbotIntegrationDetails.chatbot_id, "") 
            if(!(res.status)){
                handleError(res);
            }
        } else {
            handleError(response);
        }
        setShowDeleteConfirmation(false)
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
    }
    const handleRemoveChatbotIntegration = (phone_number_id: string, integrated_channel_id?: string) => {
        if (getChatbotIntegrationData && currentActiveWhatsappIntegration) {
            let chatbot_id = searchParams.get('chatbot_id')
            if (chatbot_id) {
                setRemoveChatbotIntegrationDetails(
                    {
                        chatbot_id: chatbot_id,
                        integrated_channel_id: integrated_channel_id ? integrated_channel_id : "0"
                    }
                )
            }
            setShowDeleteConfirmation(true)
            setPhoneNumberIntegrate(currentActiveWhatsappIntegration[0].meta_integration_phone_number_data.find((integration: metaIntegrationPhoneNumberData) => integration.phone_number_id === phone_number_id)?.display_phone_number || "")
        }
    }
    function addChatbotIntegration(phone_number_id: string, integrated_channel_id: string) {

        let chatbot_id = searchParams.get('chatbot_id')
        if (chatbot_id && currentActiveWhatsappIntegration) {
            setAddChatbotIntegrationDetails((prevState) => ({
                ...prevState,
                chatbot_id: chatbot_id,
                integrated_channel_id: integrated_channel_id
            }))
        }
        setFlagAddIntegration(true)
        setPhoneNumberIntegrate(currentActiveWhatsappIntegration?.[0]?.meta_integration_phone_number_data.find((integration: metaIntegrationPhoneNumberData) => integration.phone_number_id === phone_number_id)?.display_phone_number || "")
    }
    async function AddChatbotIntegration() {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        const response = await agent.addChatbotIntegration.post(addChatbotIntegrationDetails)
        if (response.status) {
            showSuccess("Integration Successfull!")
            setGetChatbotIntegrationData(response.data)
        } else {
            handleError(response);
        }
        setFlagAddIntegration(false)
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }
    return (
        <>
            {currentActiveWhatsappIntegration !== null && currentActiveWhatsappIntegration[0].meta_integration_phone_number_data.map((integration: metaIntegrationPhoneNumberData, index: number) => {
                return <React.Fragment key={index}>
                    <AccountInformationCard
                        key={index}
                        flagDelete={false}
                        title={`WhatsApp Account ${index + 1}`}
                        currentlySelected={integration.chatbot_integration_assignment_data.length > 0}
                        showRemoveChatbotIntegration={integration.chatbot_integration_assignment_data.filter((chatbotIntegration) => chatbotIntegration.chatbot_id.toString() == searchParams.get('chatbot_id')).length > 0}
                        removeChatbotIntegration={(phone_number_id: string, integrated_channel_id?: string) => { handleRemoveChatbotIntegration(phone_number_id, integrated_channel_id) }}
                        addChatbotIntegration={(phone_number_id, integrated_channel_id) => { addChatbotIntegration(phone_number_id, integrated_channel_id) }}
                        details={{
                            display_phone_number: integration.display_phone_number,
                            quality_rating: integration.quality_rating,
                            phone_number_id: integration.phone_number_id,
                            integrated_channel_id: integration.integrated_channel_id,
                            linked_chatbots: integration.chatbot_integration_assignment_data,
                            business_name: integration.verified_name,
                        }}
                        flagIntegration={true}
                    />
                </React.Fragment>
            })}

            {flagAddIntegration &&
                <GlobalPopUp
                    open={flagAddIntegration}
                    handleClose={() => { setFlagAddIntegration(false) }}
                    flagShowCloseIcon
                >
                    <Confirmation
                        integration='whatsapp'
                        cancel={() => { setFlagAddIntegration(false) }}
                        continue={AddChatbotIntegration}
                        confirmationMessage={`Are you sure you want to integrate ${phoneNumberIntegrate} to ${chatBotDetails?.chatbot_name}`}
                    />
                </GlobalPopUp>
            }
            {
                showDeleteConfirmation &&
                    <GlobalDeletePopup
                        title="Undeploy Chatbot Confirmation"
                        open={showDeleteConfirmation}
                        deleteDescription={`Are you sure you want to undeploy ${chatBotDetails?.chatbot_name} from ${phoneNumberIntegrate}`}
                        onClose={() => { setShowDeleteConfirmation(false) }}
                        onDelete={deleteChatbotIntegration}
                        primaryButtonText="Undeploy"
                    />
            }

        </>
    )
}

export default ChatbotWhatsAppIntegrationDetails;